ixModuleRouting("impactx.catalogruleresult", {
    "/catrule_price_change/:id": {
        template: "<ixa-catalog-rule-price-change-list></ixa-catalog-rule-price-change-list>",
        templateUrl:
            "modules/catalogruleresult/templates/catalogrulepricechangelist.html",
        controller: "CatalogRulePriceChangeListCtrl",
        controllerAs: "catalogRulePriceChangeListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catrule_deleted_products/:id": {
        template: "<ixa-catalog-rule-deleted-products-list></ixa-catalog-rule-deleted-products-list>",
        templateUrl:
            "modules/catalogruleresult/templates/catalogruledeletedproductslist.html",
        controller: "CatalogRuleDeletedProductsListCtrl",
        controllerAs: "catalogRuleDeletedProductsListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catrule_taxrates/:id": {
        template: "<ixa-catalog-rule-tax-rates-list></ixa-catalog-rule-tax-rates-list>",
        templateUrl:
            "modules/catalogruleresult/templates/catalogruletaxrateslist.html",
        controller: "CatalogRuleTaxRatesListCtrl",
        controllerAs: "catalogRuleTaxRatesListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catrule_units/:id": {
        template: "<ixa-catalog-rule-units-list></ixa-catalog-rule-units-list>",
        templateUrl:
            "modules/catalogruleresult/templates/catalogruleunitslist.html",
        controller: "CatalogRuleUnitsListCtrl",
        controllerAs: "catalogRuleUnitsListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catrule_delivery_time/:id": {
        template:"<ixa-catalog-rule-delivery-time-list></ixa-catalog-rule-delivery-time-list>",
        templateUrl:
            "modules/catalogruleresult/templates/catalogruledeliverytimelist.html",
        controller: "CatalogRuleDeliveryTimeListCtrl",
        controllerAs: "catalogRuleDeliveryTimeListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catrule_invalid_product_labels/:id": {
        template: "<ixa-catalog-rule-invalid-product-labels-list></ixa-catalog-rule-invalid-product-labels-list>",
        templateUrl:
            "modules/catalogruleresult/templates/catalogruleinvalidproductlabelslist.html",
        controller: "CatalogRuleInvalidProductLabelsListCtrl",
        controllerAs: "catalogRuleInvalidProductLabelsListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catrule_product_label_statistic/:id": {
        template: "<ixa-catalog-rule-product-label-statistic-list></ixa-catalog-rule-product-label-statistic-list>",
        templateUrl:
            "modules/catalogruleresult/templates/catalogruleproductlabelstatisticlist.html",
        controller: "CatalogRuleProductLabelStatisticListCtrl",
        controllerAs: "catalogRuleProductLabelStatisticListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catrule_no_prcode/:id": {
        template: "<ixa-catalog-rule-without-product-encryption-list></ixa-catalog-rule-without-product-encryption-list>",
        templateUrl:
            "modules/catalogruleresult/templates/catalogrulewithoutproductencryption.html",
        controller: "CatalogRuleWithoutProductEncryptionListCtrl",
        controllerAs: "catalogRuleWithoutProductEncryptionListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catrule_view_no_prcode/:id": {
        template: "<ixa-catalog-rule-without-product-encryption-view-list></ixa-catalog-rule-without-product-encryption-view-list>",
        templateUrl:
            "modules/catalogruleresult/templates/catalogrulewithoutproductencryptionview.html",
        controller: "CatalogRuleWithoutProductEncryptionViewListCtrl",
        controllerAs: "catalogRuleWithoutProductEncryptionViewListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
});
